import { ValidationCallback } from "validation/validate";

export type MentorProductBase = {
	id: string;
	price: number;
	currency: string;
	sessionDurationMinutes: number;
	sessionTypeId: string;
};

export const flagValidationErrorsInMentorProductBase: ValidationCallback<
	MentorProductBase
> = (input, { checkField }) => {
	checkField("id", { type: "string" });
	checkField("price", { type: "number" });
	checkField("currency", { type: "string" });
	checkField("sessionDurationMinutes", { type: "number" });
	checkField("sessionTypeId", { type: "string" });
};
